'use client';

import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '@/lib/animations';
import { ArrowRight, TruckIcon } from 'lucide-react';
import { Button } from './components/ui/button';

export function TPLHero() {
	return (
		<section className="relative min-h-screen flex items-center pt-16 overflow-hidden">
			{/* Background with overlay */}
			<div className="absolute inset-0 z-0">
				<div className="bg-primary-900 absolute top-0 left-0 w-screen h-full z-10 opacity-70" />
				<img
					src="https://images.pexels.com/photos/4481259/pexels-photo-4481259.jpeg"
					alt="Third-party logistics warehouse operations"
					className="w-full h-full object-cover"
				/>
			</div>

			<div className="container mx-auto px-4 md:px-6 relative z-20 py-24 md:py-32">
				<motion.div
					variants={staggerContainer}
					initial="hidden"
					animate="show"
					viewport={{ once: true, amount: 0.1 }}
					className="max-w-4xl"
				>
					<motion.div variants={fadeIn('up', 0.2)}>
						<Button className="mb-8 bg-white text-brand-600 hover:bg-gray-100 rounded-full px-4 py-2 font-medium flex items-center gap-2">
							<TruckIcon size={16} />
							Expert 3PL Solutions
						</Button>
					</motion.div>

					<motion.h1
						variants={fadeIn('up', 0.3)}
						className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
					>
						Third party logistics management in Milwaukee
					</motion.h1>

					<motion.p
						variants={fadeIn('up', 0.4)}
						className="text-xl md:text-2xl text-gray-100 mb-8 max-w-4xl leading-relaxed"
					>
						Looking for reliable third-party logistics services? Our expert team
						specializes in 3PL warehousing, offering scalable solutions designed to
						optimize your supply chain. From customized 3PL solutions to efficient 3PL
						warehouse management, we handle it all so you can focus on growing your
						business.
					</motion.p>

					<motion.div
						variants={fadeIn('up', 0.5)}
						className="flex flex-col sm:flex-row gap-4"
					>
						<Button
							asChild
							className="bg-brand-600 hover:bg-brand-700 text-white px-8 py-6 text-lg"
						>
							<a href="/contact">Get Started</a>
						</Button>
						<Button
							asChild
							variant="outline"
							className="bg-transparent text-white border-white hover:bg-white/10 px-8 py-6 text-lg"
						>
							<a href="/warehousing-solutions">
								<span>Learn More</span>
								<ArrowRight className="ml-2 h-5 w-5" />
							</a>
						</Button>
					</motion.div>
				</motion.div>
			</div>

			{/* Wave decoration */}
			<div className="absolute bottom-0 left-0 right-0">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full">
					<path
						fill="#ffffff"
						fillOpacity="1"
						d="M0,96L80,85.3C160,75,320,53,480,53.3C640,53,800,75,960,80C1120,85,1280,75,1360,69.3L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
					></path>
				</svg>
			</div>
		</section>
	);
}
